<template>
<EditingDialog 
        :showDialog="showAddRowDialog" 
        :context="context" 
        maxDialogWidth="1000" 
        maxCardHeight="880"
        :additionalAfterSaveFunction="saveApiCall" 
        :additionalCloseFunction="closeDialog"
    >
    <template v-slot:editForm>
        <v-container fluid>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context" 
                        field="CredentialsType" 
                        :items="typeDropdownOptions"
                        :disabled="!isNewRow" 
                        rules="required" 
                        :label="$t('lang_ACCOUNT_CREDENTIALS_TYPE')"
                        :selection="true" 
                        :withMargin="false" 
                        :clearable="false" 
                        :additionalFunction="toggleSave"
                        :alvqa="alvqa + '-dropdown-type'" />
                </v-col>

                <v-col></v-col>
                <v-col></v-col>
            </v-row>

            <span v-if="typeSelected !== null"> <!-- First check if the type was selected  -->
                <v-row v-if="typeSelected == 'mailchimp' || typeSelected == 'helpjuice'"> <!-- Check if the type is mailchimp or helpjuice -->
                    <v-col><!-- API textfield -->
                        <BaseEditPageTextField 
                            :context="context" 
                            field="ApiKey" 
                            rules="required" 
                            :clearable="false"
                            :label="$t('lang_SETTINGS_ACCOUNT_API_KEY')" 
                            :withMargin="false"
                            :alvqa="alvqa + '-textfield-apikey'" />
                    </v-col>
                </v-row>

                <span v-else>
                    <v-row v-if="showNameFieldsInEditForm"><!-- First, Last Name, Interests for Alv Login  -->
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context" 
                                field="FirstName" 
                                rules="required"
                                :clearable="false" 
                                :label="$t('lang_AZ_PERSONS_CAPTION_FIRST_NAME')" 
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-first-name'" />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context" 
                                field="LastName" 
                                rules="required"
                                :clearable="false" 
                                :label="$t('lang_AZ_PERSONS_CAPTION_LAST_NAME')" 
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-last-name'" />
                        </v-col>
                        <v-col>
                            <BaseEditPageDropdown 
                                :context="context" 
                                field="Interests" 
                                :items="interests"
                                :label="$t('lang_GENERIC_CAPTION_INTERESTS')" 
                                :multiple="true" 
                                rules="required" 
                                :selection="true"
                                :withMargin="false" 
                                :clearable="true" 
                                :alvqa="alvqa + '-dropdown-interests'" 
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="showNameFieldsInEditForm"> <!-- Email for ALV Login -->
                            <BaseEditPageTextField 
                                :context="context" 
                                field="Username"
                                rules="required|email"
                                :clearable="false" 
                                :label="$t('lang_ACCOUNT_CREDENTIALS_CAPTION_USERNAME_AS_EMAIL')" 
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-username'" 
                            />
                        </v-col>
                        <v-col v-else>
                            <BaseEditPageTextField 
                                :context="context" 
                                field="Username" 
                                rules="required"
                                :clearable="false" 
                                :label="$t('lang_LOGIN_CAPTION_USERNAME')" 
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-username'" 
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context" 
                                field="Password" 
                                rules="required|passwordLength"
                                :clearable="false" 
                                :label="$t('lang_CAPTION_PASSWORD')" 
                                type="password"
                                :withMargin="false" 
                                :alvqa="alvqa + '-textfield-password'" 
                            />
                        </v-col>
                        <v-col v-if="showRoleDropdown">
                            <BaseEditPageDropdown 
                                :context="context" 
                                field="Role" 
                                :items="roleDropdownOptions"
                                rules="required" 
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_ROLE')" 
                                :selection="true"
                                :withMargin="false" 
                                :clearable="false" 
                                :alvqa="alvqa + '-dropdown-role'"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="showNameFieldsInEditForm" class="mb-3">
                        <v-col 
                            class="pt-0 pb-0" 
                            v-html="$t('lang_ACCOUNT_CREDENTIALS_CAPTION_COST')"
                            :alvqa="alvqa + '-payment-text'"
                        ></v-col>
                    </v-row>
                    <v-row v-if="showOnlyOneMessage" class="mb-3">
                        <v-col 
                            class="pt-0 pb-0"
                            v-html='getOnlyBeOneMessage'
                            :alvqa="alvqa + '-can-only-be-one-message'"
                        ></v-col>
                    </v-row>
                </span>
            </span>


        </v-container>
    </template>
</EditingDialog>
</template>

<script>

import BaseDialog from '@/components/_base/BaseDialog'
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import {
    DropdownAccountCredentialsType,
    DropdownAccountCredentialsRole
} from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: 'CredentialsEditingDialog',

    data() {
        return {
            context: 'Credentials',
            alvqa: 'account-credentials-add-new-row-dialog',
            gemaAccountExists: '',
            shouldBeUniqueButIsNot: false,
            disableSaveButton: false,
            showOnlyOneMessage: false,
            showItCostsSomethingMessage: false,
        }
    },

    components: {
        BaseDialog,
        BaseButton,
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },

    computed: {
        interests() {
            let interestsArr
            let interests = this.$store.getters['getInterests']
            if (interests !== undefined) {
                interestsArr = JSON.parse(JSON.stringify(interests))
                interestsArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-type-' + element.value.toLowerCase(),
                    element['text'] = this.$t(element.text);
                });
            } else {
                interestsArr = []
            }
            return interestsArr
        },
        getOnlyBeOneMessage() {
            return this.$t("lang_GENERIC_MESSAGE_WARNING_CAN_ONLY_BE_ONE")
        },
        toggleSave() {
            this.disableSaveButton = false
            this.showOnlyOneMessage = false
            this.showItCostsSomethingMessage = false
            let newSelectedType = this.$store.getters.getCredentialsEditingDialogDetails.credentialsType
            let credentials = this.$store.getters.getCredentials
            if (credentials.length !== 0) {
                credentials.forEach(element => {
                    let type = element.credentialsType
                    if (type === newSelectedType && newSelectedType != "alv-login") {
                        this.shouldBeUniqueButIsNot = true
                        this.disableSaveButton = true
                        this.showOnlyOneMessage = true
                    } else if (newSelectedType == "alv-login") {
                        this.showItCostsSomethingMessage = true
                    }
                })
            }

        },
        showAddRowDialog: {
            get() { return this.$store.getters.getAddNewCredentialsRowDialog },
            set(show) { this.$store.commit('setAddNewCredentialsRowDialog', show) }
        },
        typeSelected: {
            get() { return this.$store.getters.getCredentialsEditingDialogDetails.credentialsType },
            set(show) { this.$store.commit('setCredentialsEditingDialogDetails', show) }
        },

        /**
         * First and last name are shown/not shown depending on type.
         * Method checks if it has to show name fileds in edit mode and creating a new row mode
         * 
         */
        // TODO_PT: better to be more granular and have one definition of which field to show in which credentialsType
        // e.g. suisa-cwr: username, pwd, host, port, 4 directories (optional) but not FIRSTNAME LASTNAME
        showNameFieldsInEditForm() {
            if (this.$store.getters.getCredentialsEditingDialogDetails.credentialsType == "alv-login")
                return true
            else
                return false
        },

        typeDropdownOptions(){
            let typesArr
            let credentialsType = this.$store.getters['getAccountCredentialsType'];
            if (credentialsType !== undefined) {
                typesArr = JSON.parse(JSON.stringify(credentialsType))
                typesArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-type-' + element.value.toLowerCase()
                    element['text'] = this.$t(element.text)
                });
            } else {
                typesArr = []
            }
            typesArr.sort(function (a, b) {
                let textA = a.text.toUpperCase();
                let textB = b.text.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            return typesArr
        },
        roleDropdownOptions() {
            return DropdownAccountCredentialsRole
        },
        isNewRow() {
            let isNewRow = this.$store.getters.getCredentialsNewRow
            return isNewRow
        },
        getUserAccountId() {
            return this.$store.getters["getUserInformation"].id
        },
        showRoleDropdown() {
            switch (this.$store.getters.getCredentialsEditingDialogDetails.credentialsType) {
                case "gema-soundfile": case "suisa-cwr":
                    this.toggleSave
                    this.$store.commit("setCredentialsDetailsRole", null)
                    this.$store.commit("setCredentialsDetailsFirstName", null)
                    this.$store.commit("setCredentialsDetailsLastName", null)
                    this.$store.commit("setCredentialsShowRoleDropdown", false)
                    return this.$store.getters.getCredentialsShowRoleDropdown
                case "alv-login":
                    this.toggleSave
                    this.$store.commit("setCredentialsShowRoleDropdown", true)
                    return this.$store.getters.getCredentialsShowRoleDropdown
            }
        },

    },

    methods: {
        saveApiCall() {
            /**
             * If user has changed the data of his/her own account,
             * the user will be automatically loged out in order to
             * refresh the token.
             */
            let editedRow = this.$store.getters.getCredentialsEditingDialogDetails
            if (editedRow.id === this.getUserAccountId) {
                //Logout after ADMIN data was changed
                this.$store.commit("setAdminInformationChanged", true)
                this.$store.dispatch("saveCredentialsRow")
            } else {
                this.$store.dispatch("saveCredentialsRow")
            }
        },
        closeDialog() {
            this.disableSaveButton = false
        },
    },

    mounted() {
        this.$store.commit('setInterests')
        this.$store.commit('setAccountCredentialsType')
    },

}
</script>

<style></style>